import { NavLink } from "react-router-dom";

import { NAV_ITEMS } from "../routes";
import { Button } from "../components/Button";
import { cx } from "../lib/cx";

interface MobileNavDrawerProps {
  open: boolean;
  onClose: () => void;
}

export function MobileNavDrawer({ open, onClose }: MobileNavDrawerProps) {
  return (
    <div className={cx("mobile-drawer-shell", open && "is-open")} aria-hidden={!open}>
      <button type="button" className="mobile-drawer-backdrop" onClick={onClose} aria-label="Close navigation" />
      <aside className="mobile-drawer" aria-label="Mobile navigation">
        <div className="row-between">
          <div>
            <div className="brand-title">400 Norwood</div>
            <div className="brand-subtitle">Investor Site</div>
          </div>
          <Button variant="ghost" onClick={onClose}>Close</Button>
        </div>
        <nav className="mobile-nav-list">
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              end
              className={({ isActive }) => cx("mobile-nav-link", isActive && "is-active")}
              onClick={onClose}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
      </aside>
    </div>
  );
}
